
// import * as XLSX from "xlsx-js-style";

// export const TimesheetExcel = (data, filters = {}) => {
//   if (!Array.isArray(data) || data.length === 0) return;

//   const ws = XLSX.utils.aoa_to_sheet([]);

//   /* ================= TITLE ================= */
//   XLSX.utils.sheet_add_aoa(ws, [["Sprint"]], { origin: "A1" });

//   ws["A1"].s = {
//     font: { bold: true, sz: 16 },
//     alignment: { horizontal: "center", vertical: "center" },
//     fill: { fgColor: { rgb: "BDD7EE" } }
//   };

//   // Merge A1 → I1
//   ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 8 } }];

//   ws["!rows"] = [{ hpt: 28 }];

//   /* ================= HEADER BLOCK ================= */
//   const headerBlock = [
//     ["Comp → Completed || PP → Project Plan", "", "", "", "", "", "", ""],

//     ["Code:", filters.Code || "", "", "", "Description:", filters.Description || "", "", ""],

//     ["From Date:", filters.FromDate || "", "", "", "To Date:", filters.ToDate || "", "", ""],

//     ["Milestone:", filters.Milestone || "", "", "", "Stages:", filters.Stages || "", "", ""],

//     ["Activities:", filters.Activities || "", "", "", "", "", "", ""],
//   ];

//   // Insert header block from B3
//   XLSX.utils.sheet_add_aoa(ws, headerBlock, { origin: "B3" });

//   /* ================= HEADER MERGES ================= */
//   ws["!merges"].push(
//     // Header title
//     { s: { r: 2, c: 1 }, e: { r: 2, c: 8 } },

//     // Code value
//     { s: { r: 3, c: 2 }, e: { r: 3, c: 4 } },

//     // Description value
//     { s: { r: 3, c: 6 }, e: { r: 3, c: 8 } },

//     // From Date value
//     { s: { r: 4, c: 2 }, e: { r: 4, c: 4 } },

//     // To Date value
//     { s: { r: 4, c: 6 }, e: { r: 4, c: 8 } },

//     // Milestone value
//     { s: { r: 5, c: 2 }, e: { r: 5, c: 4 } },

//     // Stages value
//     { s: { r: 5, c: 6 }, e: { r: 5, c: 8 } },

//     // Activities full width
//     { s: { r: 6, c: 2 }, e: { r: 6, c: 8 } }
//   );

//   /* ================= HEADER BLOCK STYLE ================= */
//   const headerStyle = {
//     font: { bold: true },
//     // alignment: { vertical: "center" }
//   };

//   // Apply bold to B3 → I7
//   for (let R = 2; R <= 6; R++) {
//     for (let C = 1; C <= 8; C++) {
//       const cell = XLSX.utils.encode_cell({ r: R, c: C });
//       if (ws[cell]) {
//         ws[cell].s = { ...headerStyle };
//       }
//     }
//   }

//   // Center main header text
//   ws["B3"].s = {
//     font: { bold: true },
//     // alignment: { horizontal: "center", vertical: "center" }
//   };

//   /* ================= TABLE DATA ================= */
//   const tableData = data.map(row => ({
//     "SL.No": row.SLNO,
//     "Date": row.DaliytaskCorrectDate,
//     "Project": row.ProjectCode,
//     "Task": [row.Description?.trim(), row.Comments?.trim()]
//                       .filter(Boolean)
//                       .join(" || "),
//     "Hrs": row.ActualHourse,
//     "Comp Date": row.DaliytaskCorrectDate?.split(" ")[0],
//     "Appr By": row.ManagerCode || "--",
//     "Appr Date": row.ApprovedDate || "",
//   }));

//   XLSX.utils.sheet_add_json(ws, tableData, { origin: "A9" });

//   const range = XLSX.utils.decode_range(ws["!ref"]);

//   /* ================= TABLE HEADER STYLE ================= */
//   const tableHeaderStyle = {
//     font: { bold: true },
//     alignment: { horizontal: "center", vertical: "center" },
//     fill: { fgColor: { rgb: "EEF3FB" } },
//     border: {
//       top: { style: "thin" },
//       bottom: { style: "thin" },
//       left: { style: "thin" },
//       right: { style: "thin" }
//     }
//   };

//   for (let C = 0; C <= 8; C++) {
//     const cell = XLSX.utils.encode_cell({ r: 8, c: C });
//     if (ws[cell]) ws[cell].s = tableHeaderStyle;
//   }

//   /* ================= ROW STYLES ================= */
//   const oddRowStyle = {
//     fill: { fgColor: { rgb: "FFFFFF" } },
//     border: {
//       top: { style: "thin" },
//       bottom: { style: "thin" },
//       left: { style: "thin" },
//       right: { style: "thin" }
//     }
//   };

//   const evenRowStyle = {
//     fill: { fgColor: { rgb: "EEF3FB" } },
//     border: {
//       top: { style: "thin" },
//       bottom: { style: "thin" },
//       left: { style: "thin" },
//       right: { style: "thin" }
//     }
//   };

//   const centerCols = [0, 1, 4, 8];

//   for (let R = 9; R <= range.e.r; R++) {
//     const base = R % 2 === 0 ? evenRowStyle : oddRowStyle;

//     for (let C = 0; C <= 8; C++) {
//       const cell = XLSX.utils.encode_cell({ r: R, c: C });
//       if (!ws[cell]) continue;

//       ws[cell].s = {
//         ...base,
//         alignment: {
//           horizontal: centerCols.includes(C) ? "center" : "left",
//           vertical: "center",
//           wrapText: true
//         }
//       };
//     }
//   }

//   /* ================= COLUMN WIDTH ================= */
//   ws["!cols"] = [
//     { wch: 6 },
//     { wch: 22 },
//     { wch: 35 },
//     { wch: 14 },
//     { wch: 10 },
//     { wch: 16 },
//     { wch: 16 },
//     { wch: 30 },
//     { wch: 14 }
//   ];

//   /* ================= EXPORT ================= */
//   const wb = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(wb, ws, "Timesheet");
//   XLSX.writeFile(wb, "Timesheet.xlsx");
// };

// export default TimesheetExcel;

import * as XLSX from "xlsx-js-style";

export const TimesheetExcel = (
  data = [],
  filters = {},
  projectName = "",
  managerName = ""
) => {
  if (!Array.isArray(data) || data.length === 0) return;

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet([]);

  const monthNames = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December"
  ];

  /* ================= TITLE (A1) ================= */
  const title = `Timesheet - ${filters.EmployeeID || ""} (${monthNames[filters.Month - 1]} - ${filters.Year})`;

  XLSX.utils.sheet_add_aoa(ws, [[title]], { origin: "A1" });

  ws["A1"].s = {
    font: { bold: true, sz: 16 },
    alignment: { horizontal: "center", vertical: "center" },
    fill: { fgColor: { rgb: "BDD7EE" } }
  };

  ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }];
  ws["!rows"] = [{ hpt: 30 }];

  /* ================= HEADER DETAILS (A3–A5) ================= */
  const headerDetails = [
    [`Project: ${projectName || ""}`],
    [`Manager: ${managerName || ""}`],
    ["Comp → Completed || Appr → Approved"],
  ];

  XLSX.utils.sheet_add_aoa(ws, headerDetails, { origin: "A3" });

  ws["!merges"].push(
    { s: { r: 2, c: 0 }, e: { r: 2, c: 7 } }, // A3
    { s: { r: 3, c: 0 }, e: { r: 3, c: 7 } }, // A4
    { s: { r: 4, c: 0 }, e: { r: 4, c: 7 } }  // A5
  );

  ["A3", "A4", "A5"].forEach(cell => {
    ws[cell].s = { font: { bold: true } };
  });

  /* ================= TABLE HEADER (A7) ================= */
  const tableHeader = [
    ["SL#", "Date", "Project", "Task", "Hrs", "Comp Date", "Appr By", "Appr Date"]
  ];

  XLSX.utils.sheet_add_aoa(ws, tableHeader, { origin: "A7" });

  const tableHeaderStyle = {
    font: { bold: true },
    alignment: { horizontal: "center", vertical: "center" },
    fill: { fgColor: { rgb: "EEF3FB" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    }
  };

  for (let C = 0; C < 8; C++) {
    const cell = XLSX.utils.encode_cell({ r: 6, c: C }); // A7
    ws[cell].s = tableHeaderStyle;
  }

  /* ================= TABLE DATA (A8+) ================= */
  const tableData = data.map((row, index) => ([
    index + 1,
    row.DaliytaskCorrectDate || "",
    row.ProjectCode || "",
    [row.Description?.trim(), row.Comments?.trim()]
      .filter(Boolean)
      .join(" || "),
    row.ActualHourse || "",
    row.DaliytaskCorrectDate?.split(" ")[0] || "",
    row.ManagerCode || "--",
    row.ApprovedDate || "",
  ]));

  XLSX.utils.sheet_add_aoa(ws, tableData, { origin: "A8" });

  /* ================= ROW STYLES ================= */
  const range = XLSX.utils.decode_range(ws["!ref"]);

  const oddRowStyle = {
    fill: { fgColor: { rgb: "FFFFFF" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    }
  };

  const evenRowStyle = {
    fill: { fgColor: { rgb: "EEF3FB" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    }
  };

  for (let R = 7; R <= range.e.r; R++) { // A8 onward
    const baseStyle = R % 2 === 0 ? evenRowStyle : oddRowStyle;

    for (let C = 0; C < 8; C++) {
      const cell = XLSX.utils.encode_cell({ r: R, c: C });
      if (!ws[cell]) continue;

      ws[cell].s = {
        ...baseStyle,
        alignment: {
          horizontal: C === 0 || C === 4 ? "center" : "left",
          vertical: "center",
          wrapText: true
        }
      };
    }
  }

  /* ================= COLUMN WIDTH ================= */
  ws["!cols"] = [
    { wch: 6 },   // SL#
    { wch: 12 },  // Date
    { wch: 12 },  // Project
    { wch: 92 },  // Task
    { wch: 8 },   // Hrs
    { wch: 12 },  // Comp Date
    { wch: 14 },  // Appr By
    { wch: 14 },  // Appr Date
  ];

  /* ================= EXPORT ================= */
  XLSX.utils.book_append_sheet(wb, ws, "Timesheet");
  XLSX.writeFile(
    wb,
    `Timesheet_${monthNames[filters.Month - 1]}_${filters.Year}.xlsx`
  );
};

export default TimesheetExcel;


